import React, { useState, useEffect } from 'react'
import { Panel, Row, Icon, Table, ButtonGroup, IconButton, Message } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import { getDownloadFileSuspended } from '../../redux/actions/suspendProject'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

export default function SuspendHistoryWidget({ data, header, ...props }) {
  const { Column, HeaderCell, Cell } = Table
  const [isFileError, setIsFileError] = useState(false)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  const onDownload = async (fileObj) => {
    startLoading()
    try {
      const file = await getDownloadFileSuspended(projectId, fileObj.id)
      const fileName = fileObj.name
      downloadFile(file, fileName)
      setIsFileError()
    } catch (e) {
      setIsFileError('ดาวน์โหลด')
    }
    doneLoading()
  }

  const onPreview = async (fileObj) => {
    startLoading()
    try {
      const file = await getDownloadFileSuspended(projectId, fileObj.id)
      const fileName = fileObj.name
      previewFile(file, fileName)
      setIsFileError()
    } catch (e) {
      setIsFileError('แสดง')
    }
    doneLoading()
  }

  return (
    <>
      <Panel header={header} collapsible shaded defaultExpanded>
        {isFileError && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="error" description={`${isFileError}ไม่สำเร็จ`} />
          </Row>
        )}
        <Table autoHeight height={300} wordWrap bordered data={data ? [...data] : []}>
          <Column width={60}>
            <HeaderCell>ครี่งที่</HeaderCell>
            <Cell dataKey="seq" />
          </Column>

          <Column width={110}>
            <HeaderCell>วันที่เสนอ</HeaderCell>
            <Cell dataKey="requestDate" />
          </Column>

          <Column width={200}>
            <HeaderCell>เหตุผล</HeaderCell>
            <Cell dataKey="requestReason" />
          </Column>

          <Column width={100}>
            <HeaderCell>ผู้เสนอ</HeaderCell>
            <Cell dataKey="requestor" />
          </Column>

          <Column width={150} align="center">
            <HeaderCell>เอกสารประกอบ</HeaderCell>
            <Cell>
              {(rowData, index) => {
                return (
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                      onClick={(e) => onPreview(rowData.file)}
                    />
                    <IconButton
                      appearance="ghost"
                      icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                      onClick={(e) => onDownload(rowData.file)}
                    />
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>

          <Column width={140}>
            <HeaderCell>วันที่อนุมัติ/ไม่อนุมัติ</HeaderCell>
            <Cell dataKey="approveDate" />
          </Column>

          <Column width={200}>
            <HeaderCell>เหตุผลการอนุมัติ/ไม่อนุมัติ</HeaderCell>
            <Cell dataKey="approvedReason" />
          </Column>

          <Column width={110}>
            <HeaderCell>ผลการพิจารณา</HeaderCell>
            <Cell>
              {(rowData) => {
                return <span>{rowData.isApproved ? 'อนุมัติ' : 'ไม่อนุมัติ'}</span>
              }}
            </Cell>
          </Column>

          <Column width={100}>
            <HeaderCell>ผู้อนุมัติ</HeaderCell>
            <Cell dataKey="approver" />
          </Column>
        </Table>
        <br />
      </Panel>
    </>
  )
}
